import WebsiteModal from "./WebsiteModal";

export default class AccommodationModal extends WebsiteModal {
    constructor($content) {
        super({
            close: {
                background: false,
            },
        });
        this.$content = $content;
    }

    buildElement() {
        this.$modal = (
            eotwJSXFactory('div', {className: "modal modal--accommodation modal--loading"}, [
                eotwJSXFactory('div', {className: "modal__overlay js-close-modal"}),
                eotwJSXFactory('div', {className: "modal__container"}, [
                    eotwJSXFactory('div', {className: "modal__content"}, [
                        eotwJSXFactory('button', {className: "modal__close-btn js-close-modal", title: "Close", 'aria-label': "Close Modal"})
                    ])
                ])
            ])
        );
        this.$modal.removeClass('modal--loading').find(".modal__content").append(
            eotwJSXFactory('div', {className: 'modal__accommodation'}, [
                this.$content
            ])
        );
    }

    destroy() {
        super.destroy();
    }
}
